module.exports = __webpack_public_path__ + "img/symmetry-warning.a8e932b4.svg";